const config = {
    mode: process.env.REACT_APP_MODE,
    mediaURL: 'https://acerecords.co.uk/cache/images/',
    jsonsUrl: '/cache/explore',
    googleAPIKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    itemsPerPage: 12,
    getMediaURL() {
        return this.mediaURL
    },
    isLive() {
        return this.mode === 'DEBUG';
    }
};


module.exports = config;
